import { ChainName } from './name'

export const EXPLORER = {
  [ChainName.ETHEREUM]: process.env.REACT_APP_ETH_EXPLORER,
  [ChainName.BASE]: process.env.REACT_APP_BASE_EXPLORER,
  [ChainName.ARC]: process.env.REACT_APP_ARC_EXPLORER
}
